import { createSlice } from '@reduxjs/toolkit';

const marginHoldSlice = createSlice({
  name: 'marginHolds',
  initialState: [],
  reducers: {
    setMarginHolds: (state, action) => {
      return action.payload;
    },
    addMarginHold: (state, action) => {
      state.push(action.payload);
    },
    clearMarginHolds: () => {
      return [];
    }
  }
});

export const { setMarginHolds, addMarginHold, clearMarginHolds } = marginHoldSlice.actions;
export const selectMarginHolds = state => state.marginHolds;
export const selectTotalMarginHeld = state => {
  const marginHolds = state.marginHolds || [];
  return marginHolds.reduce((sum, hold) => sum + (hold.holdAmount || 0), 0);
};
export default marginHoldSlice.reducer;
